import { gql } from '@apollo/client';
export const EXPORT_MY_STOCK = gql`
  query exportMyStock(
    $modelNames: [String!]
    $brandNames: [String!]
    $powerSupplies: [String!]
    $gearTypes: [String!]
    $tractionTypes: [String!]
    $regions: [String!]
    $provinces: [String!]
    $isListingActive: Boolean
    $isPriceTiedToLoan: Boolean
    $isVehicleCoveredByWarranty: Boolean
    $interiorColors: [String!]
    $coatingColors: [String!]
    $priceLabels: [PriceLabel!]
    $vehicleRegistrationDateISO8601: StringRangeInput
    $engineDisplacementInCM3: NumberRangeInput
    $powerInHP: NumberRangeInput
    $priceInEUR: NumberRangeInput
    $vehicleKM: NumberRangeInput
    $orderBy: OrderByInput
    $modelVersions: [String!]
    $optionals: [String!]
    $websites: [Website!]
    $vehicleTypes: [VehicleType!]
    $country: Country
  ) {
    exportMyStock(
      input: {
        modelNames: $modelNames
        brandNames: $brandNames
        powerSupplies: $powerSupplies
        gearTypes: $gearTypes
        tractionTypes: $tractionTypes
        regions: $regions
        provinces: $provinces
        isListingActive: $isListingActive
        isPriceTiedToLoan: $isPriceTiedToLoan
        isVehicleCoveredByWarranty: $isVehicleCoveredByWarranty
        interiorColors: $interiorColors
        coatingColors: $coatingColors
        priceLabels: $priceLabels
        vehicleRegistrationDateISO8601: $vehicleRegistrationDateISO8601
        engineDisplacementInCM3: $engineDisplacementInCM3
        powerInHP: $powerInHP
        priceInEUR: $priceInEUR
        vehicleKM: $vehicleKM
        orderBy: $orderBy
        optionals: $optionals
        modelVersions: $modelVersions
        websites: $websites
        vehicleTypes: $vehicleTypes
        country: $country
      }
    )
  }
`;
